import { RootAction } from "../types";
import { SurveyStep } from "./types";

export interface State {
  data: {
    step: SurveyStep | SurveyStep.Landing;
  };
  loading: boolean;
}

const blankState = () => ({
  data: {
    step: SurveyStep.Landing
  },
  loading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "survey/goToSurveyStep":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          step: action.step
        }
      };
  }

  return state;
};
